<app-header></app-header>
<section class="container-xxl default-height">
    <div id="section-New"></div>
    <div class="breadcrumb-area">
        <nav aria-label="breadcrumb mb-0">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a class="screen-reader" routerLink="/" [attr.title]="language=='English'?'Home':'होम'">{{ "Home" | translate }}</a></li>
                <li class="breadcrumb-item"><a class="screen-reader" routerLink="/galleryCategoryarchive" [attr.title]="language=='English'?'Archive Photo Gallery':'फोटो गैलरी संग्रहीत करें'">{{'PhotoGalleryArchive' | translate}}</a></li>
                <li class="breadcrumb-item active screen-reader">{{galleryCatNm==''?htmldecode(getTitle(categoryName)):htmldecode(galleryCatNm) }}</li>
            </ol>
        </nav>
    </div>
    <div class="inner-page-sidedetails">
        <div class="row">
            <div class="col-lg-12">
                <div class="details">
                    <div class="title d-sm-flex justify-content-between align-items-center">
                        <h2 class="screen-reader">{{galleryCatNm==''?htmldecode(getTitle(categoryName)):htmldecode(galleryCatNm) }}</h2>                        
                        <!-- <a   (click)="viewDetails(photoCatId,'gallery')"  href="javascript:void(0);" class="btn btn-sm btn-outline-success"><i class="bi bi-archive me-2"></i>{{'Gallery' | translate}}</a> -->
                    </div>

                    <div class="description mb-4" >
                        <div class="info-box" *ngIf="catwiseGallery && catwiseGallery.length > 0; else noDataTemplate">
                            <div class="gallerydetails">
                                <div class="row gallerydetails-image-area" id="gallery-container">
                                    <ng-container *ngFor="let items of catwiseGallery">
                                        <ng-container *ngFor="let photo of items.addPhotos">
                                        <div class="col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-6 gallery-item mb-2 mb-md-4"
                                            [attr.data-responsive]="this.imageUrl+photo.uploadImage"
                                            [attr.data-src]="this.imageUrl+photo.uploadImage" *ngIf="FileCheck(photo)">
                                            <a href="javascript:;" [attr.title]="language=='English'?'View Photo':'फ़ोटो देखें'"> <img [alt]="items.title"
                                                    class="gallerydetails-image screen-reader"
                                                    [src]="this.imageUrl+photo.uploadImage" alt="FCI Gallery Image">
                                                <div class="middle">
                                                    <div class="text"><i class="bi bi-zoom-in"></i></div>
                                                </div>
                                            </a>
                                        </div>
                                    </ng-container>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    <ng-template #noDataTemplate>
                           
                        <p class="screen-reader font-adjust" [style.text-align]="'center'"><b>{{ "Norecordsfound" | translate }}</b></p>

                      </ng-template>
                    </div>

                    <!-- <div class="my-4">
                        <div *ngFor="let item of galleryCatName | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords}">
                    
                            
                        </div>

                        <pagination-controls class="text-center" (pageChange)="pageChanged($event)"></pagination-controls> -->
                 
                </div>
            </div>
        </div>
    </div>
</section>
<app-clients></app-clients>
<app-footer></app-footer>